export default function IntroSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl font-light tracking-[0.14em] uppercase text-foreground-950 mb-8">
          Sofia Jewelry
        </h1>
        <div className="font-body text-sm md:text-base text-foreground-600 leading-relaxed space-y-5">
          <p>
            Family owned and operated since 1994, Sofia Jewelry is Mill Valley's
            destination jewelry store. Sofia Jewelry is located in the vibrant
            shopping scene of Mill Valley, California, just North of the Golden
            Gate Bridge. The store's successes started with Carl and Susan Priolo
            and continues with their children, Lucas and Sophie.
          </p>
          <p>
            Sofia Jewelry is a full service jewelry store in the Bay Area,
            specializing in custom creations and bespoke designs. From the Sofia
            Jewelry Collection, to various renowned artists, you will be sure to
            find something unique for every occasion and every celebration;
            engagements, Valentine's Day, birthdays, wedding, anniversary and
            just because.
          </p>
        </div>
      </div>
    </section>
  );
}